import { useMutation, useQueryClient } from 'react-query';
import Modal from '../../../../../../commons/Modal/Modal';
import Button from '../../../../../../designSystem/Button/Button';
import { BaseResponse } from '../../../../../../../types/api/api.types';
import {
  RemoveConsultationModalProps,
  RemoveConsultationQuery,
} from './RemoveConsultationModal.types';
import { useNavigate } from 'react-router-dom';
import {
  REMOVE_CONSULTATION_QUERY_KEY,
  removeConsultationQuery,
} from './RemoveConsultationModal.query';
import { ButtonColor } from '../../../../../../designSystem/Button/Button.types';

export default ({
  consultationId,
  onSuccess,
  isCompany,
  ...props
}: RemoveConsultationModalProps) => {
  const navigate = useNavigate();

  const queryClient = useQueryClient();

  const { mutate } = useMutation<Awaited<BaseResponse>, Error, RemoveConsultationQuery>(
    ({ consultationId }) => removeConsultationQuery({ consultationId }),
    {
      mutationKey: REMOVE_CONSULTATION_QUERY_KEY,
      onMutate: () => queryClient.cancelMutations(),
      onSuccess: () => {
        if (onSuccess) {
          onSuccess();
        } else {
          navigate('/dashboard/consultations');
        }
      },
      onError: (error) => {
        alert(error.message);
      },
    }
  );

  return (
    <Modal style={{ height: 'fit-content' }} {...props}>
      <p>Êtes-vous sûr de vouloir supprimer cette consultation ?</p>
      <Button
        style={{
          alignSelf: 'unset',
          textAlign: 'center',
          // borderRadius: 6,
          marginBottom: 'var(--spacing-s)',
          width: '60%',
          paddingLeft: 0,
          paddingRight: 0,
        }}
        color={isCompany ? ButtonColor.Secondary : ButtonColor.Primary}
        onClick={() => mutate({ consultationId })}>
        Oui
      </Button>
      <Button
        style={{
          alignSelf: 'unset',
          textAlign: 'center',
          // borderRadius: 6,
          marginBottom: 'var(--spacing-s)',
          width: '60%',
          paddingLeft: 0,
          paddingRight: 0,
        }}
        color={isCompany ? ButtonColor.Secondary : ButtonColor.Primary}
        onClick={() => props.setOpen(false)}>
        Non
      </Button>
    </Modal>
  );
};
